function CleaningMethod() {
  return (
    <div>
      <p> I have been trying to live a bit cleaner. It hasn't always worked but sometimes it does! It really stems from being
        tired of living in gross conditions and not having a lot of time to clean. So while sitting around one day I tried to
        pick the bare minimum that I could clean in my Bathroom each day and lined them up with each day of the week. 
         <ol>
          <li>Sunday - Sink</li>
          <li>Monday - Mirror</li>
          <li>Tuesday - Toliet</li>
          <li>Wednesday - shoWer</li>
          <li>Thursday - Trash</li>
          <li>Friday - Floors</li>
         </ol>

        And on Sabbath, We rest.

        This allows me to have an almost Perpetually clean Bathroom with minnimum effort.
        So I wrote it on a sticky not and put it next to my mirror.

        <img 
        src="/blog/CleaningMethod1.jpg"
        alt="A yellow stickynote on a white wall that has the same information as the Ordered List above"></img>

        This worked so well, I was able to clean the bathroom in like 10 minute Incruments everymorning before work.
        I then tried to add my tiny house to the mix by making a seperate one for that.
          <ol>
          <li>Sunday - Sink</li>
          <li>Monday - Matress</li>
          <li>Tuesday - Table</li>
          <li>Wednesday - Work Area</li>
          <li>Thursday - The Living Room</li>
          <li>Friday - Floors</li>
         </ol>
        
        <img 
        src="/blog/CleaningMethod2.jpg"
        alt="A yellow stickynote on a blue wall over top of a cool 3d Printed sticky note holder that has the same information as the Ordered List above"></img>

        I expected this to have the same effect, but I feel like two of these in the same day is a bit much.
        but none the less I am doing both but the second less likely but I am missing only a little bit. 
        so hopefully this can help you be cleaner too!
      </p>
    </div>
  );
}

export default CleaningMethod;
